import React, { Component } from 'react';
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';

import Style from './jsonEditor.module.css';
import { resizeContainer } from './jsonUtils';

class JsonEditorReact extends Component {
    constructor(props) {
        super(props);
        this.state = { templateJson: '' };
    }

    customOnValidate(json) {
        let errors = [];
        try {
            if ('onValidate' in this.props) {
                errors = this.props.onValidate(json || {});
            }
        } catch (err) {
            errors.push({ message: err });
        }

        // can't submit if error
        if ('setIsValid' in this.props) {
            this.props.setIsValid(errors.length === 0);
        }
        return errors;
    }

    validateJson() {
        try {
            if (this.jsoneditor) {
                this.jsoneditor.validate().then(errors => {
                    if (errors.length === 0) {
                        if ('setIsValid' in this.props) {
                            this.props.setIsValid(true);
                        }
                    }
                });
            }
        } catch (err) {
            if ('setIsValid' in this.props) {
                this.props.setIsValid(false);
            }
        }
    }

    onEditJson() {
        try {
            if (this.jsoneditor) {
                const json = this.jsoneditor.get();
                resizeContainer(this.props.id, json);
                if ('onChange' in this.props) {
                    this.jsoneditor.validate().then(errors => {
                        if (errors.length === 0) {
                            this.props.onChange(json);
                            if ('setIsValid' in this.props) {
                                this.props.setIsValid(true);
                            }
                        }
                    });
                }
                return json;
            }
        } catch (err) {
            if ('setIsValid' in this.props) {
                const text = this.jsoneditor.getText();
                resizeContainer(this.props.id, text);
                if (text.length === 0) this.props.onChange({});
                this.props.setIsValid(false);
            }
        }
    }

    componentDidMount() {
        // copy all properties into options for the editor
        // (except the properties for the JSONEditorReact component itself)
        const options = {
            mode: this.props.mode || 'code',
            showErrorTable: true,
            search: false,
            indentation: 2,
            enableSort: false,
            enableTransform: false
        };
        delete options.enableLiveAutocompletion;

        options.onValidate = json => this.customOnValidate(json);

        if (this.props && 'onChange' in this.props)
            options.onChange = () => {
                this.onEditJson();
            };

        this.jsoneditor = new JSONEditor(this.container, options);
        this.jsoneditor.resize = value => {
            resizeContainer(this.props.id, value);
            this.validateJson();
        };

        if ('json' in this.props) {
            this.setState({ templateJson: this.props.json || '{}' });
            this.jsoneditor.set(this.props.json || {});
            resizeContainer(this.props.id, this.props.json || '{}');
        }
        if ('setEditor' in this.props) {
            this.props.setEditor(this.jsoneditor);
        }
    }

    componentDidUpdate() {
        if ('mode' in this.props) {
            this.jsoneditor.setMode(this.props.mode);
        }
    }

    componentWillUnmount() {
        if (this.jsoneditor) {
            this.jsoneditor.destroy();
        }
    }

    render() {
        return <div id={this.props.id} className={Style['jsoneditor-react']} ref={elem => (this.container = elem)} />;
    }
}

JsonEditorReact.defaultProps = {
    id: 'jsoneditor'
};

export default JsonEditorReact;
